var E = /* @__PURE__ */ ((r) => (r.NEW = "NEW", r.READ = "READ", r))(E || {});
export {
  E as NotificationStatus
};
